import React from "react";
import LightSlidersIcon from "images/Light Sliders icon purple.svg";
import styles from "./utils.module.css";
import { Popover, PopoverContent, PopoverTrigger } from "@/aible/Popover/Popover";
import { Button } from "@/aible";
import ViewOptions from "@/components/ChatGPT/ViewOptions";
const DatasetViewMenuButton = () => {
    return (React.createElement("div", { className: styles.datasetButtonContainer },
        React.createElement(Popover, null,
            React.createElement(PopoverTrigger, null,
                React.createElement(Button, { className: styles.datasetViewButton },
                    React.createElement("img", { src: LightSlidersIcon, style: { width: "16px", margin: "0px" } }))),
            React.createElement(PopoverContent, { style: { width: "260px", padding: "10px" }, align: "end" },
                React.createElement(ViewOptions, null)))));
};
export default DatasetViewMenuButton;
